import { getItemByKeyValue } from '../helpers'

export interface SiteState {
  selected: SiteAccount | null
  loadingUserList?: boolean
  messages: {
    error: string
    success: string
  }
}

export const initialState = {
  selected: null,
  loadingUserList: false,
  messages: {
    error: '',
    success: '',
  },
}

export const site = (
  state: SiteState = initialState,
  action: ReduxAction,
): SiteState => {
  switch (action.type) {
    case 'GET_SELECTED_ACCOUNT':
      return {
        ...state,
        selected: {
          ...action.payload,
        },
      }
    case 'UPDATE_SELECTED_SITE': {
      if (state.selected) {
        return {
          ...state,
          selected: {
            ...state.selected,
            accountName:
              action.payload.accountName || state.selected.accountName,
            homepage: action.payload.websiteURL || state.selected.homepage,
          },
        }
      }
      return {
        ...state,
      }
    }
    case 'SET_USER_LIST_LOADING_STATUS': {
      return {
        ...state,
        loadingUserList: action?.payload?.loading,
      }
    }
    case 'SET_SITE_USERS_MESSAGE': {
      return {
        ...state,
        messages: {
          error: action?.payload?.error || '',
          success: action?.payload?.success || '',
        },
      }
    }
    case 'ADD_PENDING_USERS': {
      if (!state.selected) {
        return {
          ...state,
        }
      }
      const { pendingUserList } = state.selected
      return {
        ...state,
        selected: {
          ...state.selected,
          pendingUserList: [...(pendingUserList || []), ...action.payload],
        },
      }
    }
    case 'REMOVE_EXISTING_USER': {
      if (!state.selected) {
        return {
          ...state,
        }
      }
      const { permissionList } = state.selected
      return {
        ...state,
        selected: {
          ...state.selected,
          permissionList: permissionList?.filter((item) => {
            const { userID } = item
            return !(action.payload.userID === userID)
          }),
        },
      }
    }
    case 'UPDATE_USER_PERMISSIONS': {
      if (!state.selected) {
        return {
          ...state,
        }
      }
      const { permissionList } = state.selected
      const { userID, permissionLevel } = action.payload
      return {
        ...state,
        selected: {
          ...state.selected,
          permissionList: permissionList?.map((item) => {
            const { userID: uID, permission } = item
            return {
              ...item,
              permission: userID === uID ? permissionLevel : permission,
            }
          }),
        },
      }
    }
    case 'REVOKE_EMAIL_INVITE': {
      if (!state.selected) {
        return {
          ...state,
        }
      }
      const { pendingUserList } = state.selected
      return {
        ...state,
        selected: {
          ...state.selected,
          pendingUserList: pendingUserList?.filter((item) => {
            const { email } = item
            return !(action.payload.email === email)
          }),
        },
      }
    }
    case 'ADD_EXISTING_USERS': {
      if (!state.selected) {
        return {
          ...state,
        }
      }
      const { permissionList } = state.selected
      return {
        ...state,
        selected: {
          ...state.selected,
          permissionList: [...(permissionList || []), ...action.payload],
        },
      }
    }
    // TODO: add merge on lastLogin field
    case 'GET_USER_LIST': {
      const { pendingUserList, permissionList } = action.payload
      if (state.selected === null) {
        return {
          ...state,
        }
      }
      const modPermissionList = state.selected.permissionList
        ? permissionList.map((item) => {
            const found = getItemByKeyValue(
              state.selected?.permissionList || [],
              'userID',
              item.userID,
            )
            if (found && found.lastLogin) {
              return {
                ...item,
                lastLogin: found.lastLogin,
                email: found.email,
              }
            }
            return item
          })
        : permissionList

      return {
        ...state,
        selected: {
          ...state.selected,
          pendingUserList,
          permissionList: modPermissionList,
        },
      }
    }
    default:
      return state
  }
}
